'use strict';

/**
 * Initializes click handlers for bottom sheet modals within Page Designer rich text content areas
 * Only initializes buttons that have a data-target attribute
 * with the appropriate target modal ID
 * On desktop we rely on bootstrap's native modal functionality
 */
function initSmartAndCollect() {
    const isMobile = $('.ua-mobile').length > 0;

    $('.rich-text-content').each(function() {
        $(this).find('button').each(function() {
            const $button = $(this);
            const targetId = $button.data('target');

            if (targetId && isMobile) {
                $button.on('click', function(e) {
                    $(document).trigger('openBottomSheetRequest', { targetId: targetId });
                });
            }
        });
    });
}

module.exports = {
    initSmartAndCollect: initSmartAndCollect
};
